module.exports = __webpack_public_path__ + "images/DEV_THUMBNAIL_08-b1bc1244e29acc2eb0bfdb988dc3a1bc.jpg";